import { FC } from "react";

import { FormChip, FormChipProps } from "@/forms-design-system/FormChip";
import { useTranslate } from "@/hooks/useTranslate";

type ThemedAuctionClosedChipProps = Omit<FormChipProps, "vibe" | "variant" | "label" | "data-test">;

export const ThemedAuctionClosedChip: FC<ThemedAuctionClosedChipProps> = ({ ...rest }) => {
  const { t } = useTranslate();

  return (
    <FormChip vibe="danger" variant="outlined" label={t("common", "eventClosed")} data-test="closed-status" {...rest} />
  );
};
